import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'onlineSimulatedContainer.title',
    defaultMessage: 'Online simulated',
  },
  start: {
    id: 'onlineSimulatedContainer.start',
    defaultMessage: 'start',
  },
  at: {
    id: 'onlineSimulatedContainer.at',
    defaultMessage: 'at',
  },
  until: {
    id: 'onlineSimulatedContainer.until',
    defaultMessage: 'until',
  },
  applied: {
    id: 'onlineSimulatedContainer.applied',
    defaultMessage: 'applied',
  },
  expired: {
    id: 'onlineSimulatedContainer.expired',
    defaultMessage: 'expired',
  },
  scheduled: {
    id: 'onlineSimulatedContainer.scheduled',
    defaultMessage: 'scheduled',
  },
  cancel: {
    id: 'onlineSimulatedContainer.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'onlineSimulatedContainer.continue',
    defaultMessage: 'Continue',
  },
  content: {
    id: 'onlineSimulatedContainer.content',
    defaultMessage:
      'Fill in the form correctly, marking only one answer in each question. <br/> <br/> The end of the test is on {dateEnd} at {timeEnd}. <br/> <br/> After this time, the test will be automatically completed taking into account the questions already answered. <br/> <br/> After starting, it will not be possible to interrupt and it will not be allowed to use any other application on the computer. <br/> <br/> The use of consultation materials is not allowed. Good test!',
  },
  contentDuration: {
    id: 'onlineSimulatedContainer.contentDuration',
    defaultMessage:
      'Fill in the form correctly, checking only one answer in each question. <br/> <br/> The end of the test is at {timeEnd} in {duration}. <br/> <br/> Once you start the assessment, the duration is {duration}. <br/> <br/> After this time, the test will be automatically completed taking into account the questions already answered. <br/> <br/> After starting, it will not be possible to interrupt and it will not be allowed to use any other application on the computer. <br/> <br/> The use of materials is not allowed consultation. Good test!',
  },
  contentDurationStart: {
    id: 'onlineSimulatedContainer.contentDurationStart',
    defaultMessage:
      'Fill in the form correctly, checking only one answer in each question. <br/> <br/> Once you start the assessment, the duration is {duration}. <br/> <br/> After this time, the test will be automatically completed taking into account the questions already answered. <br/> <br/> After starting, it will not be possible to interrupt and it will not be allowed to use any other application on the computer. <br/> <br/> The use of materials is not allowed consultation. Good test!',
  },
  contentDurationContinue: {
    id: 'onlineSimulatedContainer.contentDurationContinue',
    defaultMessage:
      'Fill in the form correctly, checking only one answer in each question. <br/> <br/> The assessment has already started, track the remaining time on the next screen. <br/> <br/> After this time, the test will be automatically completed taking into account the questions already answered. <br/> <br/> After starting, it will not be possible to interrupt and it will not be allowed to use any other application on the computer. <br/> <br/> The use of materials is not allowed consultation. Good test!',
  },
  languageOption: {
    id: 'onlineSimulatedContainer.languageOption',
    defaultMessage: 'Modern Foreign Language Option',
  },
  languageEN: {
    id: 'onlineSimulatedContainer.languageEN',
    defaultMessage: 'English language',
  },
  languageES: {
    id: 'onlineSimulatedContainer.languageES',
    defaultMessage: 'Spanish language',
  },
  question: {
    id: 'onlineSimulatedContainer.questionCard.question',
    defaultMessage: 'Question',
  },
  clearChoice: {
    id: 'onlineSimulatedContainer.questionCard.clearChoice',
    defaultMessage: 'Clear my choice',
  },
  selectOption: {
    id: 'onlineSimulatedContainer.questionCard.selectOption',
    defaultMessage: 'Select one option',
  },
  previousQuestion: {
    id: 'onlineSimulatedContainer.questionCard.previousQuestion',
    defaultMessage: 'Previous question',
  },
  nextQuestion: {
    id: 'onlineSimulatedContainer.questionCard.nextQuestion',
    defaultMessage: 'Next question',
  },
  finishAttempt: {
    id: 'onlineSimulatedContainer.NavigationCard.finishAttempt',
    defaultMessage: 'Finish attempt',
  },
  questionNavigation: {
    id: 'onlineSimulatedContainer.NavigationCard.questionNavigation',
    defaultMessage: 'Questionnaire navigation',
  },
  timeRemaining: {
    id: 'onlineSimulatedContainer.NavigationCard.timeRemaining',
    defaultMessage: 'Time remaining',
  },
  prevChosenLanguage: {
    id: 'onlineSimulatedContainer.prevChosenLanguage',
    defaultMessage: 'Previously chosen language',
  },
  available: {
    id: 'onlineSimulatedContainer.available',
    defaultMessage: 'Available to perform',
  },
  ongoing: {
    id: 'onlineSimulatedContainer.ongoing',
    defaultMessage: 'In progress',
  },
  withDuration: {
    id: 'onlineSimulatedContainer.withDuration',
    defaultMessage: 'with a duration of',
  },
  finishAttemptMessage: {
    id: 'onlineSimulatedContainer.NavigationCard.finishAttemptMessage',
    defaultMessage: 'Do you want to end your attempt?',
  },
  back: {
    id: 'onlineSimulatedContainer.NavigationCard.back',
    defaultMessage: 'Back',
  },
  english: {
    id: 'onlineSimulatedContainer.english',
    defaultMessage: 'English',
  },
  spanish: {
    id: 'onlineSimulatedContainer.spanish',
    defaultMessage: 'Spanish',
  },
  composing: {
    id: 'onlineSimulatedContainer.composing',
    defaultMessage: 'Composing',
  },
  writingProposal: {
    id: 'onlineSimulatedContainer.writingProposal',
    defaultMessage: 'Writing proposal',
  },
  save: {
    id: 'onlineSimulatedContainer.save',
    defaultMessage: 'Save',
  },
  left: {
    id: 'onlineSimulatedContainer.left',
    defaultMessage: 'left',
  },
  saving: {
    id: 'onlineSimulatedContainer.saving',
    defaultMessage: 'Saving',
  },
  saved: {
    id: 'onlineSimulatedContainer.saved',
    defaultMessage: 'Saved',
  },
  characters: {
    id: 'onlineSimulatedContainer.characters',
    defaultMessage: 'characters',
  },
  startComposing: {
    id: 'onlineSimulatedContainer.startComposing',
    defaultMessage: 'Start composing',
  },
  proposal: {
    id: 'onlineSimulatedContainer.proposal',
    defaultMessage: 'Proposal',
  },
  proposalText: {
    id: 'onlineSimulatedContainer.proposalText',
    defaultMessage: 'This is the proposal content.',
  },
  text: {
    id: 'onlineSimulatedContainer.text',
    defaultMessage: 'Text',
  },
  close: {
    id: 'onlineSimulatedContainer.close',
    defaultMessage: 'Close',
  },
  composingInstructionText: {
    id: 'onlineSimulatedContainer.composingInstructionText',
    defaultMessage:
      'Write your essay in the appropriate space. </br></br>  You have a minimum limit of {minChar} characters </br>  with a maximum of {maxChar} characters. </br></br>  When finished, click "save".',
  },
  finishAttemptMinEssayMessage: {
    id: 'onlineSimulatedContainer.NavigationCard.finishAttemptMinEssayMessage',
    defaultMessage:
      'Attention! Your essay does not contain the minimum {minChar} characters.</br></br> If you save and exit now, you may be penalized in your final grade.',
  },
  finishAttemptMaxEssayMessage: {
    id: 'onlineSimulatedContainer.NavigationCard.finishAttemptMaxEssayMessage',
    defaultMessage:
      'Attention! You have reached the maximum character limit allowed.</br></br> You can save the essay as is or revise it before finalizing the submission.</br></br>Attention! Do you want to save and send the essay?',
  },
});
